import React from 'react';
import { useLang } from '../../../_LangContext';
import { UIIconSelect } from '../basic';

const UIIconSelectLang = () =>
{
	const { lang, changeLang, getAvailableLanguages } = useLang();

	const availableLanguages = getAvailableLanguages();
	const options = availableLanguages.map(langItem => (
	{
		value: langItem.code,
		//- label: langItem.key.toUpperCase(),
		label: langItem.name.toUpperCase(),
	}
	));

	const onChange = selectedOption =>
	{
		changeLang(selectedOption.value);
	};

	return (
		<UIIconSelect
			className="lang"					
			iconClass="globe"
			options={options}
			value={lang}
			onChange={onChange}
		/>
	);
};

export default UIIconSelectLang;